module.exports = "<div class=\"copyright\">{{copyright}}</div>\r\n<div class=\"version\">{{version}}</div>\r\n"


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/ui/footer/footer.component.html
// module id = ../../../../../src/app/ui/footer/footer.component.html
// module chunks = 39